import React, { useRef, useState, useEffect } from 'react';
import { SCommonTable } from 'shj-components';
import { Badge } from 'antd';
import dayjs from 'dayjs';

interface Props {
  clueId: number;
  listRef: any;
  list: any;
  open: boolean;
  setSelectedRows: (rows?: any) => void;
}
/**
 * moment类型转日期
 * @param  momentVal moment类型的日期 默认格式 年-月-日
 */
 const momentToDate = (momentVal: any, format = 'YYYY-MM-DD') => {
  // if (!moment.isMoment(momentVal)) return;
  return momentVal ? dayjs(momentVal).format(format) : null;
};
const OtherRulesExpandTable: React.FC<Props> = ({ clueId, listRef, open, list, setSelectedRows }) => {
  const tableRef = useRef<any>();
  const wrapRef = useRef<any>();
  const [authArr, setAuthArr] = useState([]);
  const [state, setState] = useState(true);

  const [_selectedRowKeys, _setSelectedRowKeys]: any = useState([]);
  const [_selectedRows, _setSelectedRows]: any = useState([]);

  useEffect(() => {
    setState(false);
    setTimeout(() => {
      setState(true);
    }, 100);
  }, [list]);

  const clearSelect = () => {
    _setSelectedRowKeys([]);
    _setSelectedRows([]);
    setSelectedRows([]);
  };
  useEffect(() => {
    clearSelect();
  }, [open]);

  const fetchData = () => {
    return new Promise((resolve: any) => {
      resolve({
        data: { data: list },
        success: true,
      });
    });
  };

  const onSelectChange = (selectedRowKeys: any, selectedRows: any) => {
    _setSelectedRowKeys(selectedRowKeys);
    _setSelectedRows(selectedRows);
    setSelectedRows(selectedRows);
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
    status: boolean;
  }

  const rowSelection = {
    type: 'radio',
    selectedRowKeys: _selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record: DataType) => ({
      disabled: record.status == false, // Column configuration not to be checked
      status: record.status,
    }),
  };
  const cols = [
    {
      title: '子规则编码',
      dataIndex: 'code',
    },
    {
      title: '子规则名称',
      dataIndex: 'name',
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 100,
      render: (text: any) => {
        return (
          <div>
            {text ? (
              <>
                <Badge status="success" />
                启用
              </>
            ) : (
              <>
                <Badge status="error" />
                禁用
              </>
            )}
          </div>
        );
      },
    },
    {
      title: '启用时间',
      dataIndex: 'enableTime',
      itemType: "dateTime",
      render: (text: any) => {
        return momentToDate(text)
      }
    },
    {
      title: '停用时间',
      itemType: "dateTime",
      dataIndex: 'stopTime',
      render: (text: any) => {
        return momentToDate(text)
      }
    },
  ];
  return state ? (
    <SCommonTable
      request={fetchData}
      toolbarTitle={'子规则列表'}
      ref={tableRef}
      tableType={'antd'}
      columns={cols}
      scroll={{ y: 400 }}
      pagination={false}
      rowSelection={rowSelection}
      size="small"
    />
  ) : null;
};

export default OtherRulesExpandTable;
